import { createRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { rootRoute } from './__root';

const searchSchema = z.object({
  to: z.string().url(),
});

export const redirectRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/redirect',
  validateSearch: searchSchema,
  component: RedirectPage,
});

function RedirectPage() {
  const { to } = redirectRoute.useSearch();

  return (
    <div className="min-h-screen bg-background flex items-center justify-center">
      <div className="text-center">
        <p className="text-muted-foreground mb-4">Redirecting to the app...</p>
        <a href={to} className="text-primary underline">
          Click here if not redirected
        </a>
      </div>
    </div>
  );
}
